import { timestampFormatter } from '@retainerclub/common';
import { useLocale } from '@retainerclub/hooks';
import PropTypes from 'prop-types';

function TableRowColumnRenewal({ subscription, billingStates }) {
  const { locale } = useLocale();

  return !billingStates.includes(subscription.state) ? (
    <span className="font-medium text-gray-600 text-xs capitalize">
      {subscription.state.replace('_', ' ')},<br />
      No renewal date available
    </span>
  ) : (
    <>
      renews on{' '}
      <span className="font-medium text-gray-600">
        {timestampFormatter(subscription.renewalAt, false)}
      </span>
      <br />
      at{' '}
      <span className="font-medium text-gray-600">
        {(subscription.subscriptionPrice / 100).toLocaleString(locale, {
          style: 'currency',
          currency: 'USD',
        })}
      </span>
    </>
  );
}

TableRowColumnRenewal.propTypes = {
  subscription: PropTypes.object.isRequired,
  // A dunning subscription still has a renewal_at - it is past due, not absent - so the states
  // that can still bill show the real date instead of "No renewal date available".
  billingStates: PropTypes.array.isRequired,
};

export default TableRowColumnRenewal;
